export const convertReactDocumentToFile = (
  reactDocument: Blob,
  documentName?: string,
) => {
  return new File([reactDocument], documentName ?? 'document.pdf');
};
